import { useState } from "react";
import ValidToast from "../toasts/ValidToast";
import UnvalidToast from "../toasts/UnvalidToast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons/faTrashCan";
import { trocRequestDelete } from "../../services/callAPI/trocsRequests";

interface IBtnIconeTrashProps {
  id: number;
  trocTId: number;
  setTrigUseEffect: React.Dispatch<React.SetStateAction<boolean>>
}

function BtnIconeTrash(props: IBtnIconeTrashProps) {
  //destructuring
  const { id, trocTId, setTrigUseEffect } = props;

  const [isShowValidToast, setIsShowValidToast] = useState<boolean>(false);

  const [isShowUnvalidToast, setIsShowUnvalidToast] = useState<boolean>(false);

  async function handleDeleteTrocRequest(id: number, trocTId: number) {
    try {
      //call API
      const response = await trocRequestDelete(id, trocTId);

      if (response.status === 204) {
        //show Validtoast
        setIsShowValidToast(true);

        setTimeout(() => {
          setTrigUseEffect(prev => !prev);
        }, 2000);
      }
      else {
        throw new Error(`Erreur lors de l'appel API, statut: ${response.status}`);
      }

    } catch (error) {
      //show UnvalidToast
      setIsShowUnvalidToast(true);

      // missing toast next 3s
      setTimeout(() => {
        setIsShowUnvalidToast(false);
      }, 3000);

    }
  }

  return (
    <>
      {isShowValidToast && <ValidToast onClose={() => setIsShowValidToast(false)} />}
      {isShowUnvalidToast && <UnvalidToast onClose={() => setIsShowUnvalidToast(false)} />}

      <button className="w-1/3 max-w-52 border-none focus:outline-none focus:ring-transparent ml-auto mr-auto" onClick={() => handleDeleteTrocRequest(id, trocTId)}>
        <i className="bg-redCustom rounded-full py-1 px-4 text-white">
          <FontAwesomeIcon icon={faTrashCan} />
        </i>
      </button>
    </>
  )
}
export default BtnIconeTrash;